import React from "react";
import { Link } from "react-router-dom";
import {
  ConfirmationModal,
  TailwindToaster,
  Pagination,
} from "../../../components";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";

import axios from "../../../api/axios";

const UserAccounts = () => {
  const state = useSelector((state) => state.UserReducer);
  const userAccountsUrl = "/user";
  const departmentsUrl = "/department";
  const teamsUrl = "/team";

  const [refreshData, setRefreshData] = React.useState(0);
  const [userAccountsData, setUserAccountsData] = React.useState([]);
  const [userAccountsServerData, setUserAccountsServerData] = React.useState(
    [],
  );
  const [currentPageIndex, setCurrentPageIndex] = React.useState(0);
  const [totalPages, setTotalPages] = React.useState(1);
  const [recordsPerPage, setRecordsPerPage] = React.useState(25);
  const getUserAccounts = (query) => {
    try {
      axios
        .get(userAccountsUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
          params: {
            query,
          },
        })
        .then((response) => {
          if (response?.data?.users?.length >= 0) {
            setUserAccountsData(response.data.users);
            setUserAccountsServerData(response.data.users);
            setTotalPages(
              Math.ceil(response.data.users.length / recordsPerPage),
            );
            setCurrentPageIndex(0);
            if (refreshData <= 0) setRefreshData(refreshData + 1);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const searchUserAccounts = (query) => {
    if (query.length > 0) {
      const tempUserAccountsData = userAccountsServerData.filter((item) => {
        const superText = (
          item.firstname +
          " " +
          item.lastname +
          " " +
          item.email +
          " " +
          item?.phone +
          " " +
          item.accountStatus +
          " " +
          item.fullname +
          " " +
          item.departmentId?.name +
          " " +
          item.aclGroup
        ).toLowerCase();
        return superText.includes(query.toLowerCase());
      });
      setUserAccountsData(tempUserAccountsData);
    } else {
      setUserAccountsData(userAccountsServerData);
    }
  };

  const [popupId, setPopupId] = React.useState(null);
  const [popupActionName, setPopupActionName] = React.useState("terminated");
  const restrictAccountAccess = (userAccountId, targetAccountStatus) => {
    try {
      axios
        .post(
          userAccountsUrl + "/change/accountstatus/" + userAccountId,
          JSON.stringify({
            accountStatus: targetAccountStatus,
          }),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: state.user.token,
            },
          },
        )
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response?.data?.message);
            init();
          } else toast.error(response?.data?.message);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const changeAccountStatus = (userAccountId, targetStatus) => {
    setPopupActionName(targetStatus);
    setPopupId(userAccountId);
  };
  const closeConfirmation = () => {
    setPopupId(null);
  };
  const popupCallback = (canProceed) => {
    if (canProceed) restrictAccountAccess(popupId, popupActionName);
    setPopupId(null);
  };

  const copyEmailToClipboard = (email) => {
    navigator.clipboard.writeText(email).then(() => {
      toast.success("Copied Email to Clipboard");
    });
  };

  const accesslevelRank = (aclGroup) => {
    switch (aclGroup) {
      case "user":
        return 1;
      case "lead":
        return 3;
      case "manager":
        return 2;
      case "admin":
        return 4;
      case "super-admin":
        return 5;
    }
  };
  const renderStatus = (status) => {
    switch (status) {
      case "NEW":
        return (
          <span className='bg-blue-100 text-blue-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded dark:bg-blue-200 dark:text-blue-800'>
            NEW
          </span>
        );
      case "BLOCKED":
        return (
          <span className='bg-orange-100 text-orange-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded dark:bg-orange-200 dark:text-orange-900'>
            BLOCKED
          </span>
        );
      case "ALLOWED":
        return (
          <span className='bg-green-100 text-green-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded dark:bg-green-200 dark:text-green-900'>
            ALLOWED
          </span>
        );
      case "TERMINATED":
        return (
          <span className='bg-red-100 text-red-600 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded dark:bg-red-200 dark:text-red-900'>
            TERMINATED
          </span>
        );
    }
  };
  const changeAccessLevel = (targetAccessLevel, userAccountId) => {
    setAccessLevelEditId(null);
    if (
      accesslevelRank(state.user.aclGroup) < accesslevelRank(targetAccessLevel)
    ) {
      toast.error("Cannot edit access above your level");

      init();
      return;
    }
    try {
      axios
        .post(
          userAccountsUrl + "/change/accesslevel/" + userAccountId,
          JSON.stringify({
            aclGroup: targetAccessLevel,
          }),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: state.user.token,
            },
          },
        )
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response?.data?.message);
            init();
          } else {
            toast.error(response?.data?.message);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const [accessLevelEditId, setAccessLevelEditId] = React.useState(null);
  const [departmentEditId, setDepartmentEditId] = React.useState(null);
  const [departmentServerData, setDepartmentServerData] = React.useState([]);
  const getDepartments = () => {
    try {
      axios
        .get(departmentsUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.departments?.length > 0) {
            setDepartmentServerData(response.data.departments);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const changeDepartment = (targetDepartmentId, userAccountId) => {
    setDepartmentEditId(null);
    try {
      axios
        .post(
          userAccountsUrl + "/change/department/" + userAccountId,
          JSON.stringify({
            departmentId: targetDepartmentId,
          }),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: state.user.token,
            },
          },
        )
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response?.data?.message);
            init();
          } else {
            toast.error(response?.data?.message);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const [teamEditId, setTeamEditId] = React.useState(null);
  const [teamServerData, setTeamServerData] = React.useState([]);
  const getTeams = () => {
    try {
      axios
        .get(teamsUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.teams?.length > 0) {
            setTeamServerData(response.data.teams);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const changeTeam = (targetTeamId, userAccountId) => {
    setTeamEditId(null);
    try {
      axios
        .post(
          userAccountsUrl + "/change/team/" + userAccountId,
          JSON.stringify({
            teamId: targetTeamId,
          }),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: state.user.token,
            },
          },
        )
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response?.data?.message);
            init();
          } else {
            toast.error(response?.data?.message);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const changePageCallback = (targetPageIndex) => {
    setCurrentPageIndex(targetPageIndex);
  };

  const changeDisplayRecordCountCallback = (targetRecordsPerPage) => {
    setRecordsPerPage(targetRecordsPerPage);
    setTotalPages(Math.ceil(userAccountsData.length / targetRecordsPerPage));
  };

  const init = () => {
    // window.scrollTo({
    //   top: 0,
    //   left: 0,
    //   behavior: "smooth",
    // });
    getUserAccounts("");
    getDepartments();
    getTeams();
  };
  const [pageTitle, setPageTitle] = React.useState("Lands & Lands ERP");
  React.useEffect(() => {
    document.title = pageTitle;
  }, [pageTitle]);

  React.useEffect(() => {
    init();
    setPageTitle("User Accounts - L&L ERP");
  }, []);

  return (
    <>
      {popupId && (
        <ConfirmationModal
          actionName={
            popupActionName === "terminated" ? (
              <strong>Terminate</strong>
            ) : popupActionName === "blocked" ? (
              <strong>Block</strong>
            ) : (
              <strong>Allow</strong>
            )
          }
          deleteConfirmation={popupCallback}
          closeConfirmation={closeConfirmation}
          moduleName={"Restrict User Account"}
          itemName={
            popupActionName === "terminated" ? (
              <>
                Account Access <strong>(cannot be reverted)</strong>
              </>
            ) : (
              ""
            )
          }
        />
      )}
      <div className='min-h-full'>
        <main className='relative'>
          <div className='max-w-8xl mx-auto py-6 sm:px-6 lg:px-8'>
            <div className='lg:flex lg:items-center justify-between'>
              <div className='flex-1 min-w-0 px-5 lg:px-0'>
                <h2 className='mt-4 ml-1 text-xl font-semibold leading-7 text-gray-dark sm:text-lg '>
                  User Accounts{" "}
                  {["manager", "lead"].includes(state.user.aclGroup) &&
                    "- " + state.user.department?.name}
                </h2>
              </div>
              <div className='flex mt-3 sm:ml-4 ml-5 sm:mr-0 mr-5'>
                <div className='grid grid-cols-4 gap-2 justify-items-end'>
                  <div className='col-span-3 w-full'>
                    <input
                      type='text'
                      name='search'
                      id='search'
                      placeholder='Search'
                      onChange={(e) => {
                        searchUserAccounts(e.target.value);
                      }}
                      maxLength='20'
                      className='focus:ring-yellow-2 focus:border-yellow-2 block w-full text-sm shadow-sm sm:text-xs read-only:bg-gray-100 read-only:opacity-50 rounded-sm'
                    />
                  </div>
                  <div>
                    <span className=''>
                      <Link to='/user/manage-user-accounts/create'>
                        <button
                          type='button'
                          className='inline-flex items-center mt-.5 px-4 py-2 border border-gray-300 rounded-sm shadow-sm sm:text-xs text-sm font-medium text-black bg-yellow hover:bg-gray-dark hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'>
                          Create
                        </button>
                      </Link>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className='px-4 py-6 sm:px-0'>
              <TailwindToaster />
              <div className='hidden md:block shadow-lg overflow-x-auto'>
                <table className='table-auto w-full shadow rounded-sm border-1 border-gray-dark '>
                  <thead className='bg-gray-50 border-b-2 border-yellow'>
                    <tr>
                      <th />
                      <th className='px-5 py-3 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                        Mobile&nbsp;#
                      </th>
                      <th className='px-5 py-3 text-gray-dark text-sm font-semibold tracking-wide text-left'>
                        Name
                      </th>
                      {state.user.aclGroup !== "manager" && (
                        <th className='px-5 py-3 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                          Department
                        </th>
                      )}
                      {state.user.aclGroup !== "manager" && (
                        <th className='px-5 py-3 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                          Team
                        </th>
                      )}
                      <th className='px-5 py-3 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                        Email&nbsp;Id
                      </th>
                      <th className='px-5 py-3 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                        Access&nbsp;Level
                      </th>
                      <th className='px-5 py-3 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                        Status
                      </th>
                      <th
                        colSpan='2'
                        className='px-5 py-3 text-gray-dark text-sm font-semibold tracking-wide text-center'>
                        Change Access
                      </th>
                    </tr>
                  </thead>
                  {refreshData !== 0 ? (
                    <tbody>
                      {userAccountsData.length > 0 ? (
                        userAccountsData.map(
                          (item, index) =>
                            index >= currentPageIndex * recordsPerPage &&
                            index < (currentPageIndex + 1) * recordsPerPage && (
                              <tr
                                key={item?._id}
                                className='hover:shadow-lg duration-300'>
                                <td className='px-5 py-3 flex justify-center'>
                                  <img
                                    src={
                                      item?.avatar
                                        ? item?.avatar
                                        : "/assets/images/user.png"
                                    }
                                    alt='User'
                                    referrerPolicy='no-referrer'
                                    className='h-7 w-7 rounded-full ring-1 ring-yellow-2'
                                  />
                                </td>
                                <td className='px-3 py-3 font-semibold text-sm text-center'>
                                  {item?.phone}
                                </td>
                                <td className='px-3 py-3 font-normal text-xs tracking-wide text-left'>
                                  {item?.fullname
                                    ? item.fullname
                                    : item.firstname}
                                </td>
                                {state.user.aclGroup !== "manager" && (
                                  <td className='px-1 py-3 font-normal text-xs tracking-wide text-center'>
                                    {departmentEditId === item?._id ? (
                                      <select
                                        onChange={(e) => {
                                          e.preventDefault();
                                          changeDepartment(
                                            e.target.value,
                                            item?._id,
                                          );
                                        }}
                                        defaultValue={item?.departmentId?._id}
                                        className='mt-1 block w-full py-2 px-3 border bg-white rounded-md shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-xs'>
                                        <option>Select</option>
                                        {departmentServerData.length > 0 ? (
                                          departmentServerData.map((item) => (
                                            <option
                                              key={item?._id}
                                              value={item?._id}>
                                              {item?.name}
                                            </option>
                                          ))
                                        ) : (
                                          <option>No Departments</option>
                                        )}
                                      </select>
                                    ) : (
                                      <div className='grid grid-cols-6'>
                                        <div className='col-span-5 overflow-x-auto peer mt-1'>
                                          <p className='peer'>
                                            {item?.departmentId?.name}
                                          </p>
                                        </div>
                                        <div
                                          className='ml-0 opacity-0 peer-hover:opacity-100 hover:opacity-100 duration-300'
                                          onClick={(e) => {
                                            setDepartmentEditId(item?._id);
                                          }}>
                                          <svg
                                            xmlns='http://www.w3.org/2000/svg'
                                            className='h-6 w-6'
                                            viewBox='0 0 20 20'
                                            fill='currentColor'>
                                            <path d='M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z' />
                                          </svg>
                                        </div>
                                      </div>
                                    )}
                                  </td>
                                )}
                                {state.user.aclGroup !== "manager" && (
                                  <td className='px-1 py-3 font-normal text-xs tracking-wide text-center'>
                                    {teamEditId === item?._id ? (
                                      <select
                                        onChange={(e) => {
                                          e.preventDefault();
                                          changeTeam(e.target.value, item?._id);
                                        }}
                                        defaultValue={item?.teamId?._id}
                                        className='mt-1 block w-full py-2 px-3 border bg-white rounded-md shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-xs'>
                                        <option>Select</option>
                                        {teamServerData.length > 0 ? (
                                          teamServerData.map((item) => (
                                            <option
                                              key={item?._id}
                                              value={item?._id}>
                                              {item?.name}
                                            </option>
                                          ))
                                        ) : (
                                          <option>No Teams</option>
                                        )}
                                      </select>
                                    ) : (
                                      <div className='grid grid-cols-6'>
                                        <div className='col-span-5 overflow-x-auto peer mt-1'>
                                          {item?.teamId?.name ? (
                                            <p className='peer'>
                                              {item.teamId.name}
                                            </p>
                                          ) : (
                                            <p className='peer text-red-700 font-semibold'>
                                              Unassigned
                                            </p>
                                          )}
                                        </div>
                                        <div
                                          className='ml-0 opacity-0 peer-hover:opacity-100 hover:opacity-100 duration-300'
                                          onClick={(e) => {
                                            setTeamEditId(item?._id);
                                          }}>
                                          <svg
                                            xmlns='http://www.w3.org/2000/svg'
                                            className='h-6 w-6'
                                            viewBox='0 0 20 20'
                                            fill='currentColor'>
                                            <path d='M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z' />
                                          </svg>
                                        </div>
                                      </div>
                                    )}
                                  </td>
                                )}
                                <td className='px-1 py-3 font-normal text-xs tracking-wide text-right'>
                                  <div className='grid grid-cols-6 gap-0 '>
                                    <div className='col-span-5 overflow-x-auto peer'>
                                      {item?.email
                                        ? item?.email.length > 30
                                          ? item?.email.slice(0, 20) +
                                            "..." +
                                            item?.email.slice(-7)
                                          : item?.email
                                        : "--"}
                                    </div>
                                    <div className='ml-0 opacity-0 peer-hover:opacity-100 hover:opacity-100'>
                                      {item?.email ? (
                                        <>
                                          <svg
                                            xmlns='http://www.w3.org/2000/svg'
                                            className='h-5 w-5 -mt-0.5'
                                            fill='none'
                                            viewBox='0 0 24 24'
                                            stroke='currentColor'
                                            strokeWidth={2}
                                            onClick={() =>
                                              copyEmailToClipboard(item?.email)
                                            }>
                                            <path
                                              strokeLinecap='round'
                                              strokeLinejoin='round'
                                              d='M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2'
                                            />
                                          </svg>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  </div>
                                </td>
                                <td className='px-2 py-3 font-semibold text-sm text-center'>
                                  {accessLevelEditId === item?._id ? (
                                    <select
                                      onChange={(e) => {
                                        e.preventDefault();
                                        changeAccessLevel(
                                          e.target.value.toLowerCase(),
                                          item?._id,
                                        );
                                      }}
                                      defaultValue={item?.aclGroup.toUpperCase()}
                                      className='mt-1 block w-full py-2 px-3 border  bg-white rounded-md shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-xs'>
                                      <option>USER</option>
                                      <option>MANAGER</option>
                                      <option>LEAD</option>
                                      <option>ADMIN</option>
                                    </select>
                                  ) : (
                                    <div className='grid grid-cols-6 '>
                                      <div className='col-span-5 overflow-x-auto peer'>
                                        <p className='peer'>
                                          {item?.aclGroup.toUpperCase()}
                                        </p>
                                      </div>
                                      <div
                                        className='ml-0 opacity-0 peer-hover:opacity-100 hover:opacity-100 duration-300'
                                        onClick={(e) => {
                                          setAccessLevelEditId(item?._id);
                                        }}>
                                        <svg
                                          xmlns='http://www.w3.org/2000/svg'
                                          className='h-6 w-6'
                                          viewBox='0 0 20 20'
                                          fill='currentColor'>
                                          <path d='M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z' />
                                        </svg>
                                      </div>
                                    </div>
                                  )}
                                </td>
                                <td className='px-2 py-3 font-normal text-xs tracking-wide text-center'>
                                  {renderStatus(
                                    item?.accountStatus.toUpperCase(),
                                  )}
                                </td>
                                {item?.accountStatus !== "terminated" ? (
                                  item?.accountStatus === "allowed" ? (
                                    <td
                                      onClick={(e) => {
                                        changeAccountStatus(
                                          item?._id,
                                          "blocked",
                                        );
                                      }}
                                      className='px-5 py-3 text-sm font-semibold hover:bg-gray-100 text-yellow text-center cursor-pointer'>
                                      BLOCK
                                    </td>
                                  ) : (
                                    <td
                                      onClick={(e) => {
                                        changeAccountStatus(
                                          item?._id,
                                          "allowed",
                                        );
                                      }}
                                      className='px-5 py-3 text-sm font-semibold hover:bg-gray-100 text-yellow-2 text-center cursor-pointer'>
                                      ALLOW
                                    </td>
                                  )
                                ) : (
                                  <td />
                                )}
                                {item?.accountStatus !== "terminated" ? (
                                  <td
                                    onClick={(e) => {
                                      changeAccountStatus(
                                        item?._id,
                                        "terminated",
                                      );
                                    }}
                                    className='px-5 py-3 text-sm font-semibold hover:bg-gray-100 text-red-600 text-center cursor-pointer'>
                                    TERMINATE
                                  </td>
                                ) : (
                                  <td />
                                )}
                              </tr>
                            ),
                        )
                      ) : (
                        <tr className='hover:shadow-lg duration-300'>
                          <td
                            className='px-5 py-3 font-normal text-sm tracking-wide text-center'
                            colSpan='7'>
                            No data available to display
                          </td>
                        </tr>
                      )}
                    </tbody>
                  ) : (
                    <tbody>
                      <tr>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='bg-yellow-2 h-6 w-6 rounded-full '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td
                          className='px-5 py-3 font-normal text-sm tracking-wide text-center'
                          colSpan='2'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-6 bg-yellow-2 h-6 rounded-full '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td className='px-5 py-3 font-normal text-sm tracking-wide text-center'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                        <td
                          className='px-5 py-3 font-normal text-sm tracking-wide text-center'
                          colSpan='2'>
                          <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                            <div className='w-full bg-yellow-2 h-6 rounded-md '></div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  )}
                </table>
                {userAccountsData.length > 0 && (
                  <Pagination
                    pages={totalPages}
                    currentPage={currentPageIndex}
                    recordsPerPage={recordsPerPage}
                    changePageCallback={changePageCallback}
                    totalRecords={userAccountsData?.length}
                    changeDisplayRecordCountCallback={
                      changeDisplayRecordCountCallback
                    }
                  />
                )}
              </div>
              <div className='block md:hidden'>
                <div className='grid grid-cols-1 gap-4'>
                  {userAccountsData.length > 0 ? (
                    userAccountsData.map((item) => (
                      <div
                        key={item?._id}
                        className='px-2 py-2 shadow  border-b-2 border-gray-100'>
                        <div className='grid grid-cols-6'>
                          <div className='col-span-5'>
                            <h4 className='text-gray-dark font-semibold text-sm tracking-wide pl-2 pt-1'>
                              {item?.phone}
                            </h4>
                            <h4 className='text-gray-dark font-semibold text-sm tracking-wide pl-2 pt-0 text-left'>
                              {item?.fullname ? item.fullname : item.firstname}
                            </h4>
                          </div>
                          <div className='col-span-1 pr-2 pt-2 grid justify-items-right'>
                            <img
                              src={
                                item?.avatar
                                  ? item?.avatar
                                  : "/assets/images/user.png"
                              }
                              alt='avatar'
                              referrerPolicy='no-referrer'
                              className='h-10 w-10 rounded-full ring-1 ring-yellow-2'
                            />
                          </div>
                          <div className='col-span-6'>
                            <h4 className='text-gray-dark font-bold text-sm tracking-wide pl-2 pt-1 text-left'>
                              {accessLevelEditId === item?._id ? (
                                <select
                                  onChange={(e) => {
                                    e.preventDefault();
                                    changeAccessLevel(
                                      e.target.value.toLowerCase(),
                                      item?._id,
                                    );
                                  }}
                                  defaultValue={item?.aclGroup.toUpperCase()}
                                  className='mt-1 block w-full py-2 px-3 border bg-white rounded-md shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-xs'>
                                  <option>USER</option>
                                  <option>LEAD</option>
                                  <option>MANAGER</option>
                                  <option>ADMIN</option>
                                </select>
                              ) : (
                                <div className='grid grid-cols-6 '>
                                  <div className='col-span-5 overflow-x-auto peer'>
                                    <p
                                      className='peer'
                                      onClick={(e) => {
                                        setAccessLevelEditId(item?._id);
                                      }}>
                                      {item?.aclGroup.toUpperCase()}
                                    </p>
                                  </div>
                                </div>
                              )}
                            </h4>
                          </div>
                          <div className='col-span-6 pl-2'>
                            {item?.email
                              ? item?.email.length > 25
                                ? item?.email.slice(0, 15) +
                                  "..." +
                                  item?.email.slice(-7)
                                : item?.email
                              : "--"}
                          </div>
                          {state.user.aclGroup !== "manager" && (
                            <div className='col-span-2'>
                              <div>
                                {departmentEditId === item?._id ? (
                                  <select
                                    onChange={(e) => {
                                      e.preventDefault();
                                      changeDepartment(
                                        e.target.value,
                                        item?._id,
                                      );
                                    }}
                                    defaultValue={item?.departmentId?._id}
                                    className='block w-full py-1 px-3 border bg-white rounded-md shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-xs'>
                                    <option>Select</option>
                                    {departmentServerData.length > 0 ? (
                                      departmentServerData.map((item) => (
                                        <option
                                          key={item?._id}
                                          value={item?._id}>
                                          {item?.name}
                                        </option>
                                      ))
                                    ) : (
                                      <option>No Departments</option>
                                    )}
                                  </select>
                                ) : (
                                  <div className='grid grid-cols-6 font-semibold'>
                                    <div className='col-span-5 overflow-x-auto peer'>
                                      <p
                                        className='text-gray-dark  text-sm tracking-wide pl-2 pt-1 text-left'
                                        onClick={(e) => {
                                          setDepartmentEditId(item?._id);
                                        }}>
                                        {item?.departmentId?.name}
                                      </p>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                          {state.user.aclGroup !== "manager" && (
                            <div className='col-span-2'>
                              <div>
                                {teamEditId === item?._id ? (
                                  <select
                                    onChange={(e) => {
                                      e.preventDefault();
                                      changeTeam(e.target.value, item?._id);
                                    }}
                                    defaultValue={item?.teamId?._id}
                                    className='block w-full py-1 px-3 border bg-white rounded-md shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-xs'>
                                    <option>Select</option>
                                    {teamServerData.length > 0 ? (
                                      teamServerData.map((item) => (
                                        <option
                                          key={item?._id}
                                          value={item?._id}>
                                          {item?.name}
                                        </option>
                                      ))
                                    ) : (
                                      <option>No Teams</option>
                                    )}
                                  </select>
                                ) : (
                                  <div className='grid grid-cols-6 font-semibold'>
                                    <div className='col-span-5 overflow-x-auto peer'>
                                      {item?.teamId ? (
                                        <p
                                          className='text-gray-dark  text-sm tracking-wide pl-2 pt-1 text-left'
                                          onClick={(e) => {
                                            setTeamEditId(item?._id);
                                          }}>
                                          {item?.teamId?.name}
                                        </p>
                                      ) : (
                                        <p
                                          className='text-red-700  text-sm tracking-wide pl-2 pt-1 text-left overflow-hidden'
                                          onClick={(e) => {
                                            setTeamEditId(item?._id);
                                          }}>
                                          Unassigned
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                          <div
                            className={`${
                              state.user.aclGroup !== "manager"
                                ? "col-span-2"
                                : "col-span-6"
                            } pt-1 text-right`}>
                            <div>
                              {renderStatus(item?.accountStatus.toUpperCase())}
                            </div>
                          </div>
                          <div className='col-span-6 pt-2 pr-2'>
                            <div className='grid grid-cols-2 gap-2'>
                              {item?.accountStatus !== "terminated" ? (
                                item?.accountStatus === "allowed" ? (
                                  <div
                                    onClick={(e) => {
                                      changeAccountStatus(item?._id, "blocked");
                                    }}
                                    className='px-5 py-3 text-sm font-semibold hover:bg-gray-100 text-yellow text-center cursor-pointer'>
                                    BLOCK
                                  </div>
                                ) : (
                                  <div
                                    onClick={(e) => {
                                      changeAccountStatus(item?._id, "allowed");
                                    }}
                                    className='px-5 py-3 text-sm font-semibold hover:bg-gray-100 text-yellow-2 text-center cursor-pointer'>
                                    ALLOW
                                  </div>
                                )
                              ) : (
                                <div />
                              )}
                              {item?.accountStatus !== "terminated" ? (
                                <div
                                  onClick={(e) => {
                                    changeAccountStatus(
                                      item?._id,
                                      "terminated",
                                    );
                                  }}
                                  className='px-5 py-3 text-sm font-semibold hover:bg-gray-100 text-red-600 text-center cursor-pointer'>
                                  TERMINATE
                                </div>
                              ) : (
                                <div />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className='px-3 py-2'>
                      <h4 className='text-lg font-semibold'>
                        No data to display
                      </h4>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default UserAccounts;
